import { useKey } from 'react-use';

type UseConsoleShortcutsArgs = {
  focus?: () => void;
};
const useConsoleShortcuts = ({ focus }: UseConsoleShortcutsArgs): void => {
  return useKey(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
    true,
    (event) => {
      const key = String.fromCharCode(event.keyCode);
      if (event.ctrlKey && !event.altKey && key === '2') {
        event.preventDefault();
        if (focus != null) {
          focus();
        }
      }
      return false;
    },
    { event: 'keydown' },
    [focus],
  );
};

export default useConsoleShortcuts;
